import { memo } from 'react';

// Components
import Select from '../../../../components/Select';
import Textbox from '../../../../components/Textbox';

// Types
import {
  SignifierLevelOption,
  SignifierLevelSelection,
} from '../../../../types';

export type SignifierInputValue = {
  level: SignifierLevelSelection;
  stringValue: string;
};

const LEVEL_OPTIONS: SignifierLevelOption[] = [
  { label: 'customer.descriptive_name', value: 'customer.descriptive_name' },
  { label: 'campaign.name', value: 'campaign.name' },
  { label: 'adGroup.name', value: 'adGroup.name' },
];

interface BrandSignifierInputsProps {
  index: number;
  value: SignifierInputValue;
  isRemoveable: boolean;
  onRemove: (index: number) => void;
  onChange: (val: SignifierInputValue, index: number) => void;
}

function BrandSignifierInputs({
  index,
  value,
  onChange,
  onRemove,
  isRemoveable,
}: BrandSignifierInputsProps) {
  const onChangeLevel = (level: SignifierLevelSelection) => {
    onChange({ ...value, level }, index);
  };

  const onChangeString = (strVal: string) => {
    onChange({ ...value, stringValue: strVal.trim() }, index);
  };

  // JSX
  return (
    <div className="relative grid grid-cols-2 gap-8">
      <Select
        label="Level"
        tooltip="onboarding.brand_signifiers.level"
        placeholder="Enter level"
        options={LEVEL_OPTIONS}
        value={value.level}
        onChange={onChangeLevel}
        required
      />
      <Textbox
        label="String"
        tooltip={
          <div className="px-4">
            <span>Enter the string value for the brand signifier:</span>
            <ul className="list-disc">
              <li>
                Follow consistent naming conventions to maintain clarity across
                campaigns.
              </li>
            </ul>
          </div>
        }
        placeholder="Enter string value"
        onChange={onChangeString}
        value={value.stringValue}
        pattern="^[~&-]?[a-zA-Z0-9_Ѐ-ӿ]([-&]?_?[a-zA-Z0-9_Ѐ-ӿ])*[~&-]?$"
        required
      />
      {isRemoveable ? (
        <i
          id="x-icon"
          className="absolute top-0 right-0"
          onClick={() => onRemove(index)}
        />
      ) : null}
    </div>
  );
}

export default memo(BrandSignifierInputs);
